// extracted by mini-css-extract-plugin
export default {"ChoiceInput":"styles_ChoiceInput__5r-To"};